import { createApp } from 'vue'
import { io } from 'socket.io-client'
import App from './App.vue'
import "./assets/css/reset.css"

const socket = io('ws://localhost:3000')
const app = createApp(App)

app.provide('socket', socket)
app.mount('#app')
